<template>
    <div class="markGoodInfo" v-if="date">
        <Icon type="md-checkmark-circle-outline" />
        <span class="tag2">病程好转</span>
        <span class="tag">最佳诊疗方案购买条件</span>
        <span>|</span>
        <span>{{ date }}</span>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    props: {
        info: {
            type: Object,
            default: () => ({}),
        },
        keyStr:{
            type: String,
            default: "markGood"
        }
    },
    computed: {
        ...mapGetters(["indexSpin"]),
    },
    watch: {
        info() {
            this.init();
        }
    },
    data() {
        return {
            date: "",
        };
    },
    methods: {
        setDate(date) {
            this.date = date;
        },
        init(){
            this.date = "";
        }
    },
    mounted() {
        this.$bus.on(this.keyStr, this.setDate);
    },
    beforeDestroy() {
        this.$bus.off(this.keyStr, this.setDate);
    },
};
</script>

<style lang="scss" scoped>
.markGoodInfo {
    font-weight: bold;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    color: #2aa645;
    border-radius: 4px;
    border: 1px solid #2aa64566;

    &>* {
        margin-right: 10px;
    }

    .ivu-icon {
        padding: 0;
        font-size: 22px;
    }

    .tag {
        background: #2aa645;
        border-radius: 3px;
        color: #fff;
        font-size: 12px;
        padding: 2px 10px;
    }
}
</style>